import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Async Modal",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-async-modal",
    args: {
        closeButtonText: "",
        closeOnBackdropClick: false,
        closeOnEscKey: false,
        name: "async1",
        noCloseButton: false,
        opened: false,
        reloadOnClose: false,
        src: "./mock-data/async-modal/async-modal.html",
        stickyPosition: "center",
    },
    argTypes: {
        closeButtonText: { control: "text" },
        closeOnBackdropClick: { control: "boolean" },
        closeOnEscKey: { control: "boolean" },
        name: { control: "text" },
        noCloseButton: { control: "boolean" },
        opened: { control: "boolean" },
        reloadOnClose: { control: "boolean" },
        src: { control: "text" },
        stickyPosition: {
            control: { type: "radio" },
            options: ["bottom", "center", "top"],
        },
    },
};

const Template = ({
    closeButtonText,
    closeOnBackdropClick,
    closeOnEscKey,
    name,
    noCloseButton,
    opened,
    reloadOnClose,
    src,
    stickyPosition,
}) =>
    html`<button class="ux-button" data-trigger-async-modal="open,async1">
            Open Async Modal</button
        ><ux-iws-async-modal
            close-button-text="${closeButtonText}"
            close-on-backdrop-click="${closeOnBackdropClick}"
            close-on-esc-key="${closeOnEscKey}"
            name="${name}"
            no-close-button="${noCloseButton}"
            opened="${opened}"
            reload-on-close="${reloadOnClose}"
            src="${src}"
            sticky-position="${stickyPosition}"
        ></ux-iws-async-modal>`;

const TemplateVariableSrc = () => html`<ux-iws-async-modal
        name="async1"
    ></ux-iws-async-modal>
    <button
        class="ux-button"
        data-trigger-async-modal="open,async1,./mock-data/async-modal/async-modal.html"
    >
        Open Async Modal 1
    </button>
    <button
        class="ux-button"
        data-trigger-async-modal="open,async1,./mock-data/async-modal/async-modal-2.html"
    >
        Open Async Modal 2
    </button>`;

export const Default = Template.bind({});

export const ReloadOnClose = Template.bind({});
ReloadOnClose.args = {
    src: "./mock-data/async-modal/async-modal-reload.html",
};

export const VariableSrc = TemplateVariableSrc.bind({});
